module.exports = __webpack_public_path__ + "static/media/vw301318.cfbefed1.png";